module.exports = __webpack_public_path__ + "static/media/default-card.9e15ba6d.png";